import React, { useCallback } from 'react';
import { useImportProject } from '@client/hooks/use-import.hooks';
import { FileWithPath } from 'react-dropzone';
import { create } from 'zustand';
import ImportElementsDialog from './ImportElementsDialog';

export const useImportProjectDialogStore = create<{
  open: boolean;
  setOpen: (open: boolean) => void;
}>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));

const ImportProjectDialog: React.FC = () => {
  const importProject = useImportProject();
  const { open, setOpen } = useImportProjectDialogStore();

  const closeDialog = () => setOpen(false);

  const handleImport = useCallback(
    async (files: readonly FileWithPath[]): Promise<void> => {
      setOpen(false);
      await importProject(files);
    },
    [importProject, setOpen],
  );

  return (
    <ImportElementsDialog
      open={open}
      title="Import project"
      content="Drag JSON file here"
      acceptedFormats={['.json']}
      onImport={handleImport}
      onClose={closeDialog}
    />
  );
};

export default ImportProjectDialog;
